import { gql } from "@apollo/client";

export const GET_POST = gql`
  query Post($where: PostWhereInputOne!) {
    post(where:$where) {
      id
      page
      pageName
      detail
      description
      fbFeedId
      title
      status
      createdAt
      updatedAt
    	shop{
        id
      }
  }
}
`;

export const GET_POSTS = gql`
  query Posts($where: PostWhereInput, $orderBy: OrderByInput, $skip: Int, $limit: Int) {
  posts(where: $where, orderBy: $orderBy, skip: $skip, limit: $limit) {
    total
    data {
      id
      page
      pageName
      detail
      description
      fbFeedId
      fbFeedIds
      title
      status
      pageAccessToken
      shop{
        id
      }
      createdAt
      updatedAt
    }
  }
}
`;